import { Link } from 'react-router-dom';

import { getNavItems, NAV_ZONES } from './navigation.config';
import ThemeAwareLogo from './ThemeAwareLogo';
import NavItem from './NavItem';
import ThemeToggle from './ThemeToggle';

function DesktopNavbar({ isAuthed = false, badges = {}, userImage = null }) {
  const items = getNavItems({
    zone: NAV_ZONES.DESKTOP,
    isAuthed,
    badges,
  });

  return (
    <nav className="pNavbar" aria-label="Основна навігація">
      <div className="row">
        <div className="p-nav-item nav-logo">
          <Link to="/feed" aria-label="Рієстро — на головну">
            <ThemeAwareLogo
              className="nav-logo-img theme-aware-logo"
              lightSrc="/images/logo-nobg.png"
              darkSrc="/images/logo-dark-nobg.png"
            />
            <ThemeAwareLogo
              className="nav-logo-full theme-aware-logo"
              lightSrc="/images/logo-full-nobg.png"
              darkSrc="/images/logo-full-dark-nobg.png"
            />
          </Link>
        </div>

        {items.map((item) => (
          <NavItem
            key={item.id}
            item={item}
            userImage={item.avatarKey === 'userImage' ? userImage : undefined}
          />
        ))}

        <div className="p-nav-item d-none d-lg-block mt-auto">
          <ThemeToggle />
        </div>

        <div className="mt-2 text-center d-none d-lg-flex">
          <small className="mx-auto">&#169; Рієстро</small>
        </div>
      </div>
    </nav>
  );
}

export default DesktopNavbar;
